var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"item",attrs:{"active-class":"primary","ripple":""},on:{"click":_vm.handleClick}},[_c('v-list-item-icon',[(_vm.isSelected)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" check_box ")]):_c('v-icon',[_vm._v(" check_box_outline_blank ")])],1),_c('v-list-item-content',[_vm._v(" "+_vm._s(_vm.source.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }